import { render, staticRenderFns } from "./DialogWrapper.vue?vue&type=template&id=bbbd1890&scoped=true&"
import script from "./DialogWrapper.vue?vue&type=script&lang=js&"
export * from "./DialogWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DialogWrapper.vue?vue&type=style&index=0&id=bbbd1890&scoped=true&lang=css&"
import style1 from "./DialogWrapper.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbd1890",
  null
  
)

export default component.exports